module.exports = __webpack_public_path__ + "img/circle.3e96db20.png";